module.exports = __webpack_public_path__ + "img/logo-sm.d4787334.svg";